import React from "react";
import  QrCodeIcon  from "../assets/images/icon/qrcode.svg";

export default function AfterBanner({showPopup}) {
  return (
    <div
      id="mission&vision"
      className="relative flex justify-center w-full py-16 md:py-20 text-sky-800 dark:text-white"
    >
      <div className="w-10/12 md:w-9/12 grid md:grid-cols-2 gap-12">
        <div>
          <h5 className="text-3xl text-center md:text-left md:text-5xl font-bold">
            Mission and Vision<br></br>
            <span className="dark:text-sky-500">
              Google Developers Student Clubs UIT
            </span>
          </h5>
          
        <br/>

        <div className=" w-full col-span-3  flex items-center bg-gray-100 rounded-lg p-6">

          <img  height={"86px"}
                width={"86px"}
                src={QrCodeIcon}
          />
                <div className="p-4 ml-4">
                  <p className="text-gray-500 dark:text-gray-400">
                    Scan to Open
                  </p>
                </div>
              </div>



        </div>
        <div className="text-center md:text-left">
          <p className="text-gray-500 dark:text-gray-400">
          GDSC-UIT is home to all the students who love to help build a proactive community using their technical and non-technical skills. GDSC enables students to learn and take their interest in Google developer Technologies to the next step by developing solutions through their learning implementations. It is indeed a very purposive platform for the tech-savvy students to polish their communication skills, grow their connection pool, be part of beneficial seminars, get to know the best entrepreneurs, enjoy success stories, learn the nitty-gritty of working in a team, develop project-building skills, etc.


          </p>
          <br />
          <p className="text-gray-500 dark:text-gray-400">
         
Being part of GDSC enables students to not only learn and listen to others' stories but to bring their own unique ideas to the table and implement solutions to the problems. The reason the world recognizes them as the "problem-solving real HEROS!" 
          </p>
          <div className="flex flex-col items-center md:items-start">
            <h1 className="text-xl text-center md:text-left mt-10 md:text-3xl font-bold">
            Approach GDSC UIT on any social media platform: 
            </h1>
            <a target="__blank" href="https://linktr.ee/gdscuit" className="py-4 mt-7 px-8 bg-sky-100 text-sky-800 dark:bg-sky-500 rounded-full dark:text-white dark:hover:bg-sky-600 hover:shadow-lg hover:shadow-sky-500/25">
              Explore Link Tree
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
